import { Form, Input, message, Modal, Radio, Select, Space, Table } from 'antd'
import type { ColumnsType } from 'antd/es/table'
import './index.less'
import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { deleteManageItem, getManageList, updateManageItem } from '@/server'
import { useAppSelector } from '@/hooks'

function UserPageFunc(props, ref) {
  const token = useAppSelector((state) => state.login.token)
  interface DataType {
    key: string
    loginName: string
    displayName: string
    email: string
    groupname: string
    groupAdmin: string
    password: string
    rules: any
    role: number
    enable: boolean
  }

  const roleOptions = [
    {
      value: 0,
      label: '大众'
    },
    {
      value: 1,
      label: '专家'
    },
    {
      value: 2,
      label: '管理员'
    }
  ]

  const defaultUserData: Array<DataType> = []

  const getBackendData = () => {
    getManageList({}, 'user', token)
      .then((res) => {
        const curUserData: Array<DataType> = []
        const rawUserList = res.data.content
        for (const user of rawUserList) {
          curUserData.push({
            key: user.username,
            loginName: user.username,
            displayName: user.displayname,
            email: user.email,
            groupname: user.groupname,
            groupAdmin: user.groupadmin,
            password: user.password,
            rules: user.rules,
            role: user.role,
            enable: user.enable
          })
        }
        setUserData(curUserData)
        updateDicts()
      })
      .catch((err) => {
        console.log(err)
      })
  }

  useImperativeHandle(ref, () => ({
    rerender: () => {
      getBackendData()
    }
  }))

  useEffect(() => {
    getBackendData()
  }, [])

  const [userData, setUserData] = useState(defaultUserData)
  const [curEditUser, setCurEditUser] = useState<DataType | null>(null)

  const [open, setOpen] = useState(false)
  const [confirmOpen, setConfirmOpen] = useState(false)
  const [curDelUserKey, setCurDelUserKey] = useState('')

  const [enableUser, setEnableUser] = useState({})
  const [keyToName, setKeyToName] = useState({})
  const updateDicts = () => {
    const tmpEnableUser = {}
    const tmpKeyToName = {}
    for (const user of userData) {
      tmpEnableUser[user.key] = user.enable
      tmpKeyToName[user.key] = user.loginName
    }
    setEnableUser(tmpEnableUser)
    setKeyToName(tmpKeyToName)
  }
  useEffect(() => {
    updateDicts()
  }, [userData])

  const columns: ColumnsType<DataType> = [
    {
      title: '登录姓名',
      dataIndex: 'loginName',
      key: 'loginName',
      // defaultSortOrder: 'ascend',
      sorter: (a, b) => a.loginName?.localeCompare(b.loginName)
    },
    {
      title: '显示姓名',
      dataIndex: 'displayName',
      key: 'displayName',
      // defaultSortOrder: 'ascend',
      sorter: (a, b) => a.displayName?.localeCompare(b.displayName)
    },
    {
      title: '电子邮件',
      dataIndex: 'email',
      key: 'email',
      // defaultSortOrder: 'ascend',
      sorter: (a, b) => a.email?.localeCompare(b.email)
    },
    {
      title: '分组',
      dataIndex: 'groupname',
      key: 'groupname',
      filters: props.groupOptions.map((item) => {
        return {
          text: item.label,
          value: item.value
        }
      }),
      onFilter: (value, record) => record.groupname === value,
      // defaultSortOrder: 'ascend',
      sorter: (a, b) => a.groupname?.localeCompare(b.groupname)
    },
    {
      title: '分组管理员',
      dataIndex: 'groupAdmin',
      key: 'groupAdmin',
      // defaultSortOrder: 'ascend',
      sorter: (a, b) => a.groupAdmin?.localeCompare(b.groupAdmin)
    },
    {
      title: '适用规则',
      dataIndex: 'rules',
      key: 'rules',
      // defaultSortOrder: 'ascend',
      // sorter: (a, b) => a.rules?.localeCompare(b.rules),
      render: (text, _record, _index) => {
        const str = text?.join(', ')
        return <div>{str}</div>
      }
    },
    {
      title: '用户类型',
      dataIndex: 'role',
      key: 'role',
      sorter: (a, b) => a.role - b.role,
      render: (role, _record, _index) => {
        const str = role === 0 ? '大众' : role === 1 ? '专家' : '管理员'
        return <div>{str}</div>
      }
    },
    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <Space size='middle'>
          <a
            style={{ color: 'rgb(136, 113, 52)' }}
            onClick={(_e) => {
              setCurEditUser(record)
              setOpen(true)
            }}
          >
            编辑
          </a>
          <Radio.Group
            value={enableUser[record.key]}
            onChange={(e) => {
              if (e.target.value === enableUser[record.key]) return
              updateManageItem(
                {
                  username: record.key,
                  enable: e.target.value
                },
                'user',
                token
              )
                .then((_res) => {
                  message.success('修改成功！')
                  const tmpEnableUser = JSON.parse(JSON.stringify(enableUser))
                  tmpEnableUser[record.key] = e.target.value
                  setEnableUser(tmpEnableUser)
                })
                .catch((err) => {
                  message.error('修改失败，请重试！')
                  console.log(err)
                })
            }}
          >
            <Radio.Button value={true}>启用</Radio.Button>
            <Radio.Button value={false}>禁用</Radio.Button>
          </Radio.Group>
          <a
            style={{ color: 'rgb(136, 113, 52)' }}
            onClick={(_e) => {
              setCurDelUserKey(record.key)
              setConfirmOpen(true)
            }}
          >
            移除
          </a>
        </Space>
      )
    }
  ]

  const [form] = Form.useForm()
  useEffect(() => {
    if (!open || !curEditUser) return
    form.setFieldsValue({
      displayName: curEditUser.displayName,
      password: curEditUser.password,
      email: curEditUser.email,
      groupname: curEditUser.groupname,
      role: curEditUser.role
    })
  }, [open, curEditUser, form])

  const onEdit = (values) => {
    if (!curEditUser) return
    updateManageItem(
      {
        username: curEditUser.key,
        displayname: values.displayName,
        email: values.email,
        groupid: props.groupToId[values.groupname],
        password: values.password,
        role: values.role
      },
      'user',
      token
    )
      .then((_res) => {
        message.success('修改成功！')
        getBackendData()
        setOpen(false)
      })
      .catch((err) => {
        message.error('修改失败，请重试！')
        console.log(err)
      })
  }
  return (
    <>
      <Modal
        open={confirmOpen}
        title='提示'
        okText='确定'
        cancelText='取消'
        onCancel={() => {
          setConfirmOpen(false)
        }}
        onOk={() => {
          deleteManageItem(curDelUserKey, 'user', token)
            .then((_res) => {
              message.success('删除成功！')
              const tmpUserData = userData.filter((item) => item.key !== curDelUserKey)
              setUserData(tmpUserData)
              getBackendData()
              setConfirmOpen(false)
            })
            .catch((err) => {
              message.error('删除失败，请重试！')
              console.log(err)
            })
        }}
      >
        是否确认移除{keyToName[curDelUserKey]}
      </Modal>
      <Modal
        open={open}
        title='编辑成员信息'
        okText='确定'
        cancelText='取消'
        onCancel={() => {
          setOpen(false)
        }}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              form.resetFields()
              onEdit(values)
            })
            .catch((info) => {
              console.log('Validate Failed:', info)
            })
        }}
      >
        <Form form={form} layout='vertical' name='edit' initialValues={{ modifier: 'public' }}>
          <Form.Item
            name='displayName'
            label='显示姓名'
            rules={[
              {
                required: true,
                message: '请输入成员显示姓名'
              }
            ]}
          >
            <Input placeholder='请输入成员显示姓名' />
          </Form.Item>
          <Form.Item
            name='password'
            label='密码'
            rules={[
              {
                required: true,
                message: '请输入成员登录密码'
              }
            ]}
          >
            <Input placeholder='请输入成员登录密码' />
          </Form.Item>
          <Form.Item
            name='email'
            label='电子邮件'
            rules={[
              {
                required: false,
                message: '请输入成员电子邮件'
              }
            ]}
          >
            <Input placeholder='请输入成员电子邮件' />
          </Form.Item>
          <Form.Item
            name='groupname'
            label='分组'
            rules={[
              {
                required: true,
                message: '请选择成员分组'
              }
            ]}
          >
            <Select options={props.groupOptions} />
          </Form.Item>
          <Form.Item
            name='role'
            label='用户类型'
            rules={[
              {
                required: true,
                message: '请选择用户类型'
              }
            ]}
          >
            <Select options={roleOptions} />
          </Form.Item>
          {/* <Form.Item
            name="isAdmin"
            label="是否设置该用户为该组管理员"
            initialValue={curEditAdmin}
            rules={[
              {
                required: true,
                message: '请选择'
              }
            ]}
          >
            <Switch />
          </Form.Item> */}
        </Form>
      </Modal>
      <Table columns={columns} dataSource={userData} />
    </>
  )
}

const UserPage = forwardRef(UserPageFunc)
export { UserPage }
